import { get, head } from 'lodash';
import { getPaymentsList } from '../../states/payments/getPaymentsList';
import { getChapsPaymentsList } from '../../states/chaps/selectors';
import { TYPE_CHAPS, TYPE_SO } from '../../config';

export const getCalendarDates = (state) => get(state, 'calendar.dates', []);
export const getSubmissionDates = (state) => getCalendarDates(state).map((date) => date.submission);

export const getSettlementDateForSubmissionDate = (state, submissionDate) => {
	if (!submissionDate) return undefined;
	const date = getCalendarDates(state).find((date) => date.submission.isSame(submissionDate));
	return date ? date.settlement : undefined;
};
const replacementDateIndex = 1;
export const getReplacementDates = (state) => getCalendarDates(state)[replacementDateIndex];

const getCalendarCutOffs = (state) => get(state, 'calendar.cut_offs', []);

export const getNextAvailableDate = (state) =>
	get(head(getCalendarCutOffs(state).filter(({ type }) => type === TYPE_SO)), 'next_available_date');

export const getChapsNextAvailableDate = (state) =>
	get(head(getCalendarCutOffs(state).filter(({ type }) => type === TYPE_CHAPS)), 'next_available_date');

export const checkIfPastCutOff = (state) =>
	Boolean(
		getCalendarCutOffs(state).length > 0 &&
			getPaymentsList(state).filter(({ date }) => date.isBefore(getNextAvailableDate(state))).length
	);

export const checkIfPastChapsCutOff = (state) =>
	Boolean(
		getCalendarCutOffs(state).length > 0 &&
			getChapsPaymentsList(state).filter(({ date }) => date.isBefore(getChapsNextAvailableDate(state))).length
	);

export const getFirstSubmissionDate = (state) => get(head(getCalendarDates(state)), 'submission');
